import { styled } from '@linaria/react';
import { Text } from '@daedalus/atlas/Text';
export const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "we3wvha",
  propsAsIs: false
});
export const MobileWrapper = /*#__PURE__*/styled('div')({
  name: "MobileWrapper",
  class: "m143cr36",
  propsAsIs: false
});
const _exp5 = /*#__PURE__*/() => Text;
export const PlaceNameWrapper = /*#__PURE__*/styled(_exp5())({
  name: "PlaceNameWrapper",
  class: "p2ejmqz",
  propsAsIs: true
});
export const MapLink = /*#__PURE__*/styled('span')({
  name: "MapLink",
  class: "mapkyb1",
  propsAsIs: false
});
export const LocationSummaryWrapper = /*#__PURE__*/styled('div')({
  name: "LocationSummaryWrapper",
  class: "l11v0f45",
  propsAsIs: false
});
const _exp10 = /*#__PURE__*/() => Text;
export const StreetViewText = /*#__PURE__*/styled(_exp10())({
  name: "StreetViewText",
  class: "s5ohhgp",
  propsAsIs: true
});

require("./styles.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.ts");